export const EShapeActionOpenExtensions = wcardinal.ui.EShapeActionOpenExtensions;